/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OAuthTokenResult { 
    /**
     * Scope
     */
    scope?: string;
    /**
     * Token Type
     */
    token_type?: string;
    /**
     * Access Token
     */
    access_token?: string;
    /**
     * Access Token Expires In Time (ms)
     */
    expires_in?: number;
    /**
     * Refresh Token
     */
    refresh_token?: string;
}

